import { SET_USER } from "../ConstAction";

const initialState = {};
export const userData = (state = initialState, action) => {

  switch (action.type) {

    case SET_USER:
      return {
        ...state,
        userData: action.response.data,
      };
    default:
      return { ...state };
  }
};
